import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { FaTimes } from "react-icons/fa";

export default function POClosedModal({
  open,
  setOpen,
  onConfirmClose,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  onConfirmClose?: () => void;
}) {
  const cancelButtonRef = useRef(null);
  const { getRouteKey } = useRouter();
  const { purchaseOrderDetails: PODetails } = useRouteInfo(getRouteKey("INVENTORY", "id")).routeState
    .state as IInventoryState;

  const handleClose = () => {
    setOpen(false);
  };

  const handleYesClose = () => {
    if (onConfirmClose) onConfirmClose();
    setOpen(false);
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 sm:w-[480px] sm:p-6 flex flex-col `}
                >
                  <button onClick={handleClose} className="absolute top-6 right-3 text-gray-500 hover:text-gray-700">
                    <FaTimes size={16} />
                  </button>
                  <div className="pb-2">
                    <div className="font-semibold text-sm">CAUTION: GRN Incomplete</div>
                  </div>
                  <div>
                    <p>
                      The GRN is still incomplete.{" "}
                      <span className="font-semibold">{PODetails?.short_item_receive_count} items</span> are short
                      received!
                    </p>
                    <p>Are you sure to close the GRN?</p>
                    <div className="mt-4 flex items-center gap-2">
                      <input type="checkbox" className="cursor-pointer" />
                      <p>I acknowledge there might be some issues later</p>
                    </div>
                  </div>
                  <div>
                    <div className="mt-6 flex justify-end gap-3">
                      <button
                        onClick={handleClose}
                        className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md"
                      >
                        Go Back
                      </button>
                      <button className="px-5 py-2 text-sm bg-[#193A6A] text-white rounded-md" onClick={handleYesClose}>
                        Yes, Close
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
